<i18n src="./langs.yaml"></i18n>
<template>
  <div>
    <div v-if="AREA === 'US'" class="landing">
      <div class="block11">
        <div class="desc desc1">
          {{
            $t('pzn_automaticdistributionlanding_Description_us_block1-desc1')
          }}
        </div>
        <div class="title">
          {{ $t('a-d-landing-block1-title') }}
        </div>
        <div class="desc desc3">
          {{
            $t('pzn_automaticdistributionlanding_Description_us_block1-desc2')
          }}
        </div>
        <div class="desc desc4">
          {{
            $t('pzn_automaticdistributionlanding_Description_us_block1-desc3')
          }}
        </div>
        <div class="desc desc5">
          {{
            $t('pzn_automaticdistributionlanding_Description_us_block1-desc4')
          }}
        </div>
      </div>
      <div class="block2">
        <div class="title">
          {{ $t('a-d-landing-block2-title') }}
        </div>
        <div
          class="desc desc2"
          v-html="
            $t('pzn_automaticdistributionlanding_Description_us_block2-desc1')
          "
        />
        <div class="tit tit3">
          {{ $t('a-d-landing-block2-tit2') }}
        </div>
      </div>
      <div class="block3">
        <div class="title">
          {{ $t('a-d-landing-block3-title') }}
        </div>
        <div
          class="desc desc2"
          v-html="
            $t('pzn_automaticdistributionlanding_Description_us_block3-desc1')
          "
        />
      </div>
      <div class="block4">
        <div class="title">
          {{ $t('pzn_automaticdistributionlanding_SubTitle_us_block4-title') }}
        </div>
        <div class="desc desc2">
          {{
            $t('pzn_automaticdistributionlanding_Description_us-block4-desc2')
          }}
        </div>
        <div class="desc desc3">
          {{
            $t('pzn_automaticdistributionlanding_Description_us-block4-desc3')
          }}
        </div>
        <div class="desc desc4">
          {{
            $t('pzn_automaticdistributionlanding_Description_us-block4-desc4')
          }}
        </div>
        <div class="img-box img-box3">
          <div class="relative">
            <div
              class="tip"
              v-html="
                $t(
                  'pzn_automaticdistributionlanding_Description_us-block4-tip-text1'
                )
              "
            />
            <img src="./img5.png" />
          </div>
          <div class="relative">
            <div class="tip">
              {{
                $t(
                  'pzn_automaticdistributionlanding_Description_us-block4-tip-text2'
                )
              }}
            </div>
            <img src="./img6.png" />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="AREA === 'JP'" class="landing">
      <div
        style="text-align: center; font-size: 22px"
        v-html="$t('a-d-landing-block1-jp-navTitle')"
      ></div>
      <div class="block11">
        <div class="desc desc1">
          {{
            $t('pzn_automaticdistributionlanding_Description_jp_block1-desc1')
          }}
        </div>
        <div class="title">
          {{ $t('a-d-landing-block1-jp-title') }}
        </div>
        <div class="desc desc3">
          {{
            $t('pzn_automaticdistributionlanding_Description_jp_block1-desc2')
          }}
        </div>
        <div class="desc desc4">
          {{
            $t('pzn_automaticdistributionlanding_Description_jp_block1-desc3')
          }}
        </div>
        <div
          class="desc desc5"
          v-html="
            $t('pzn_automaticdistributionlanding_Description_jp_block1-desc4')
          "
        ></div>
      </div>
      <div class="block2">
        <div class="title">
          {{ $t('a-d-landing-block2-jp-title') }}
        </div>
        <div
          class="desc desc2"
          v-html="
            $t('pzn_automaticdistributionlanding_Description_jp_block2-desc1')
          "
        />
        <div class="tit tit3">
          {{ $t('a-d-landing-block2-jp-tit2') }}
        </div>
      </div>
      <div class="block3">
        <div class="title">
          {{ $t('a-d-landing-block3-jp-title') }}
        </div>
        <div
          class="desc desc2"
          v-html="
            $t('pzn_automaticdistributionlanding_Description_jp_block3-desc1')
          "
        />
      </div>
      <div class="block4">
        <div class="title">
          {{ $t('pzn_automaticdistributionlanding_SubTitle_us_block4-title') }}
        </div>
        <div class="desc desc2">
          {{
            $t('pzn_automaticdistributionlanding_Description_us-block4-desc2')
          }}
        </div>
        <div class="desc desc3">
          {{
            $t('pzn_automaticdistributionlanding_Description_us-block4-desc3')
          }}
        </div>
        <!-- <div class="desc desc4">
          {{
            $t('pzn_automaticdistributionlanding_Description_us-block4-desc4')
          }}
        </div> -->
        <div class="img-box img-box3">
          <div class="relative">
            <div
              class="tip"
              v-html="
                $t(
                  'pzn_automaticdistributionlanding_Description_us-block4-tip-text1'
                )
              "
            />
            <img src="./img5.png" />
          </div>
          <div class="relative">
            <div class="tip">
              {{
                $t(
                  'pzn_automaticdistributionlanding_Description_us-block4-tip-text2'
                )
              }}
            </div>
            <img src="./img6.png" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="landing">
      <div class="block1">
        <div class="desc desc1">
          {{ mySlot('a-d-landing-block1-desc1') }}
        </div>
        <div class="title">
          {{ mySlot('a-d-landing-block1-title') }}
        </div>
        <div class="desc desc2">
          {{ getI18NValue('a-d-landing-block1-desc2') }}
        </div>
        <div class="desc desc3">
          {{ mySlot('a-d-landing-block1-desc3') }}
        </div>
        <div class="desc desc4">
          {{ mySlot('a-d-landing-block1-desc4') }}
        </div>
        <div class="desc desc5">
          {{ mySlot('a-d-landing-block1-desc5') }}
        </div>
        <div class="tit tit1" v-html="mySlot('a-d-landing-block1-tit1')" />
        <div class="img-box img-box1">
          <div class="relative">
            <div class="tip">{{ mySlot('a-d-landing-tip-text1') }}</div>
            <img src="./img1.png" />
          </div>
          <div class="relative">
            <div class="tip">{{ mySlot('a-d-landing-tip-text2') }}</div>
            <img src="./img2.png" />
          </div>
        </div>
      </div>
      <div class="block2">
        <div class="title">
          {{ mySlot('a-d-landing-block2-title') }}
        </div>
        <div class="tit tit2">
          {{ mySlot('a-d-landing-block2-tit1') }}
        </div>
        <div
          class="desc desc2"
          v-html="getI18NValue('a-d-landing-block2-desc1')"
        />
        <div class="tit tit3">
          {{ mySlot('a-d-landing-block2-tit2') }}
        </div>
      </div>
      <div class="block3">
        <div class="title">
          {{ mySlot('a-d-landing-block3-title') }}
        </div>
        <div
          class="desc desc4"
          v-html="getI18NValue('a-d-landing-block3-desc1')"
        />
      </div>
      <div class="block4">
        <div class="title">
          {{ mySlot('a-d-landing-block4-title') }}
        </div>
        <div class="desc desc5" v-html="mySlot('a-d-landing-block4-desc1')" />
        <div class="table">
          <div class="left" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text1') }}
          </div>
          <div class="right" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text2') }}
          </div>
          <div class="left" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text3') }}
          </div>
          <div class="right" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text4') }}
          </div>
          <div class="left" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text5') }}
          </div>
          <div class="right" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text6') }}
          </div>
          <div class="left" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text7') }}
          </div>
          <div class="right" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text8') }}
          </div>
          <div class="left text9" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text9') }}
          </div>
          <div class="right text10" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text10') }}
          </div>
        </div>
        <div class="table">
          <div class="left" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text11') }}
          </div>
          <div class="right" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text12') }}
          </div>
          <div class="left" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text13') }}
          </div>
          <div class="right" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text14') }}
          </div>
          <div class="left" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text15') }}
          </div>
          <div class="right" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text16') }}
          </div>
          <div class="left" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text17') }}
          </div>
          <div class="right" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text18') }}
          </div>
          <div class="left text19" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text19') }}
          </div>
          <div class="right text20" :style="$t('table.style')">
            {{ mySlot('a-d-landing-table-text20') }}
          </div>
        </div>
        <div class="img-box img-box2">
          <div class="relative">
            <div class="tip">{{ mySlot('a-d-landing-tip-text3') }}</div>
            <img :src="imgSrc3" />
          </div>
          <div class="relative">
            <div class="tip">{{ mySlot('a-d-landing-tip-text4') }}</div>
            <img :src="imgSrc4" />
          </div>
        </div>
        <div
          class="desc desc6"
          :style="$t('table.style')"
          v-html="mySlot('a-d-landing-block4-desc2')"
        />
      </div>
      <div v-if="AREA === 'KR'" class="block5">
        <div class="title">
          {{ mySlot('a-d-landing-block5-title') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc1') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc2') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc3') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc4') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc5') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc6') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc7') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc8') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block5-desc9') }}
        </div>
      </div>
      <div v-if="AREA === 'KR'" class="block6">
        <div class="title">
          {{ mySlot('a-d-landing-block6-title') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc1') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc2') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc3') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc4') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc5') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc6') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc7') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc8') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc9') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc10') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc11') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc12') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc13') }}
        </div>
        <div class="desc">
          {{ mySlot('a-d-landing-block6-desc14') }}
        </div>
      </div>
    </div>
    <div v-if="!isApply" class="submit-box" @click="submit">
      <DuButton class="submit">{{
        mySlot('a-d-landing-submit-text')
      }}</DuButton>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { getDulang, waitForPageData } from '@du/dulang-vue2'
import createTrackConfig from './trackConfig'
import Jockeys from '@/utils/jockeys'
import { DuButton } from '@/components'
import { DEYI_DEFAULT_TEXT } from '@/config'

const LangPageId = 'P_ee99f0e2d8614024aa6d16b223ecb813'
const dulang = getDulang()
const { getSlot } = dulang
const mySlot = getSlot(LangPageId)

export default Vue.extend({
  components: {
    DuButton
  },
  // async asyncData({ query }) {
  //   await waitForPageData([LangPageId])
  //   return { apply: query.apply === 'false' }
  // },
  data() {
    const { apply = '' } = this.$route.query
    return {
      isApply: apply === 'false'
    }
  },
  head() {
    return {
      title: this.$t('a-d-landing-block1-navTitle'),
      meta: [
        { property: 'og:type', content: 'website' },
        {
          property: 'og:title',
          content: this.$t('a-d-landing-block1-navTitle')
        }
      ]
    }
  },
  computed: {
    ...mapState(['LANG', 'AREA']),
    imgSrc3() {
      if (this.AREA === 'KR') {
        return 'https://cdn.poizon.com/node-common/f55fb796-1365-2e26-e515-db56733d841c-403-256.jpg'
      }
      return require('./img3.png')
    },
    imgSrc4() {
      if (this.AREA === 'KR') {
        return 'https://cdn.poizon.com/node-common/e2abdc10-86e3-de35-45b2-d08f288d3845-345-220.png'
      }
      return require('./img4.png')
    }
  },
  beforeCreate() {
    this.$fontTransform.run(this.$i18n.vm.messages)
  },
  mounted() {
    Jockeys.setTitle(this.$t('a-d-landing-block1-navTitle'))
    Jockeys.rightBarButtonItem({
      title: this.$t('a-d-landing-block1-navTitle'),
      description: this.$t('a-d-landing-block1-navTitle'),
      link: `${location.href}&apply=false`
    })
    const { withVueTrack } = require('@du/analytics-sdk/dist/analytics-sdk.es')
    withVueTrack({ createTrackConfig }, this)
    this.$track('poizon_page_pageview')
  },
  methods: {
    mySlot,
    submit() {
      Jockeys.closeCurrentPage(true)
    },
    getI18NValue(key) {
      const val = this.mySlot(key)
      if (this.LANG === 'en' || this.LANG === 'zh-TW') {
        const res = this.mySlot(`${key}${this.AREA}`)
        if (res && res === DEYI_DEFAULT_TEXT) {
          return val
        } else {
          return res
        }
      }
      return val
    }
  }
})
</script>
<style lang="scss" scoped>
.landing {
  padding: 64px 40px 200px;
}
.desc {
  font-family: 'PingFang HK';
  font-size: 26px;
  line-height: 48px;
  color: #14151a;
  &.desc1 {
    margin-bottom: 48px;
  }
  &.desc5 {
    margin-bottom: 24px;
  }
  &.desc6 {
    text-align: right;
    font-family: PingFang SC;
    font-weight: 300;
    font-size: 24px;
    line-height: 32px;
    color: #14151a;
  }
}
.block11,
.block3,
.block5,
.block6 {
  margin-bottom: 64px;
}
.title {
  margin-bottom: 24px;
  font-family: 'PingFang HK';
  font-size: 36px;
  font-weight: 500;
  line-height: 42px;
  color: #000000;
}
.tit {
  font-family: 'PingFang HK';
  font-size: 26px;
  font-weight: 500;
  line-height: 48px;
  color: #14151a;
  &.tit1 {
    margin-bottom: 24px;
  }
  &.tit3 {
    margin-bottom: 64px;
  }
}
.img-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .relative {
    position: relative;
  }
  img {
    display: block;
    width: auto;
  }
  &.img-box1 {
    margin-bottom: 64px;
    img {
      height: 274px;
    }
  }
  &.img-box2 {
    margin-bottom: 14px;
    img {
      height: 214px;
    }
  }
  &.img-box3 {
    margin-bottom: 14px;
    padding: 0 40px;
    img {
      height: 300px;
    }
  }
}

.tip {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
  padding: 8px;
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 36px;
  color: #ffffff;
  background-color: #29292e;
  border-radius: 4px;
}

.table {
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  div {
    height: 64px;
    padding: 0 16px;
    margin: 0 2px 2px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFang HK;
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #14151a;
    background-color: #f5f5f9;
  }
  .left {
    width: 288px;
  }
  .right {
    width: 378px;
    margin-right: 0;
  }
  .text9,
  .text10,
  .text19,
  .text20 {
    height: 128px;
  }
}
.submit-box {
  padding: 20px 16px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  background-color: #fff;
}
.submit {
  width: 718px;
  font-weight: 600;
}
</style>
